"use client";

import type React from "react";
import { Carousel } from "@boostdev/design-system-components/client";
import { useClientTranslation } from "@/lib/i18n/client";
import type { ProductImage } from "@/lib/shop/types";
import css from "./Gallery.module.css";

export interface GalleryProps {
  images: ProductImage[];
  title: string;
  locale: string;
}

function resolveImageSrc(image: ProductImage): string {
  if (image.immichAssetId) return `/api/immich/display/${image.immichAssetId}`;
  if (image.storagePath) return image.storagePath;
  return "";
}

export function Gallery({ images, title, locale }: GalleryProps): React.JSX.Element {
  const { t } = useClientTranslation(locale, "shop");

  if (images.length === 0) {
    return (
      <div
        className={css.placeholder}
        aria-label={t("product.galleryEmpty")}
        role="img"
      />
    );
  }

  const slides = images.map((image) => (
    <img
      key={image.id}
      src={resolveImageSrc(image)}
      alt={image.alt ?? title}
      className={css.slide}
    />
  ));

  return (
    <Carousel
      items={slides}
      label={t("product.gallery")}
    />
  );
}
